
export enum MediaAssetClient {
  MediaAssetClientAWSS3 = "awss3",
  MediaAssetClientCloudflare = "cloudflare",
  MediaAssetClientCloudflareR2 = "cloudflare-r2",
}

export type MediaAsset = {
  _id: string;
  field: string;
  key: string;
  collection: string; // ModelNames
  collectionID: string;
  mediaAssetClient: MediaAssetClient;
  createdAt: Date;
  updatedAt: Date;
};
